import { EVENT } from "@/constants/event";

/**
 * 筛选器选项值类型
 * @typedef {Object} FilterValue
 * @property[object Object]string} label - 显示标签
 * @property[object Object]string} value - 选项值
 * @property {string} [icon] - 图标
 * @property {string} [optionLabel] - 选项标签
 */

/**
 * 选中的筛选器类型
 * @typedef {Object.<string, FilterValue|Array<FilterValue>|null>} SelectedFilters
 */

/**
 * 筛选器状态类型
 * @typedef {Object} FilterState
 * @property {boolean} isFilterVisible - 筛选器是否可见
 */

/**
 * 筛选器模块方法类型
 * @typedef {Object} FilterActions
 * @property {function(): number} getSelectedCount - 获取选中的筛选项数量
 * @property {function(SelectedFilters): void} setSelectedFilters - 设置选中的筛选项
 * @property {function(): void} clearSelectedFilters - 清空选中的筛选项
 */

/**
 * Zustand store 的 set 和 get 函数类型
 * @typedef {Object} StoreAPI
 * @property {function(Object|function): void} set - 设置状态的函数
 * @property {function(): FilterState & FilterActions} get - 获取状态的函数
 */

/**
 * 筛选器模块
 * @param {function} set - Zustand 的 set 函数，用于更新状态
 * @param {function} get - Zustand 的 get 函数，用于获取当前状态
 * @returns {FilterState & FilterActions} 筛选器模块的状态和方法
 */
export default function filter(set, get) {
  return {
    isFilterVisible: false,
    /**
     * 设置筛选器可见性
     * @param[object Object]boolean} visible - 是否可见
     */
    setFilterVisible: (visible) => {
      set({ isFilterVisible: visible });
      window.dispatchEvent(
        new CustomEvent(EVENT.FILTER_VISIBLE_CHANGE, { detail: visible })
      );
    },
    /**
     * 获取选中的筛选项数量
     * @returns {number} 选中的筛选项数量
     */
    getSelectedCount: () => {
      const state = get();
      const selectedFilters = state.selectedFilters || {};
      return Object.keys(selectedFilters).length;
    },
    /**
     * 设置选中的筛选项
     * @param {SelectedFilters} filters - 筛选器对象
     */
    setSelectedFilters: (filters) => {
      set({ selectedFilters: filters });
    },
    /**
     * 清空选中的筛选项
     */
    clearSelectedFilters: () => {
      set({ selectedFilters: {} });
    },
  };
}
